(() => {
  const cart = document.querySelector('cart-items');
  if (!cart) return;
  let busy = false;
  async function change(input, quantity) {
    if (busy) return;
    busy = true;
    const controls = [...cart.querySelectorAll('button, input')];
    controls.forEach(el => el.disabled = true);
    const error = document.getElementById('cart-errors');
    if (error) error.textContent = '';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line: Number(input.dataset.index), quantity})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your cart.');
      window.location.reload();
    } catch (e) {
      if (error) error.textContent = e.message;
      controls.forEach(el => el.disabled = false);
      busy = false;
    }
  }
  cart.addEventListener('click', event => {
    const button = event.target.closest('.quantity__button');
    const remove = event.target.closest('cart-remove-button a');
    if (!button && !remove) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const input = (button || remove).closest('.cart-item__quantity-wrapper').querySelector('input[name="updates[]"]');
    if (!input) return;
    const current = Number(input.value);
    const step = Number(input.step) || 1;
    const min = Number(input.min) || 1;
    const quantity = remove ? 0 : button.name === 'minus' ? (current - step < min ? 0 : current - step) : current + step;
    change(input, quantity);
  }, true);
  cart.addEventListener('change', event => {
    const input = event.target.closest('input[name="updates[]"]');
    if (!input) return;
    event.stopImmediatePropagation();
    if (Number.isInteger(Number(input.value)) && Number(input.value) >= 0) change(input, Number(input.value));
  }, true);
})();
